import type * as ecModels from '../../../models'
import * as plugin from '../../plugin'

import { getActionsConfig } from './actions'
import { Config } from './config'
import * as extraReducers from './extra-reducers'
import * as models from './models'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages attributes of the entities in the entity collection
 */
export class Plugin<
  TTypeParams extends ecModels.TypeParams.Constraint,
> extends plugin.Plugin<
  TTypeParams,
  plugin.Plugin.Id.Standard.Cache,
  State<TTypeParams>,
  Selectors<TTypeParams>,
  ReturnType<typeof getActionsConfig<TTypeParams>>
> {
  /**
   * @see {@link Plugin.constructor.Params.maxEntities}
   */
  public readonly config: Readonly<Config>

  constructor({ collection, config }: Plugin.constructor.Params<TTypeParams>) {
    const finalConfig = Config.from(config)
    super({
      actions: getActionsConfig<TTypeParams>(collection, finalConfig),
      collection,
      id: plugin.Plugin.Id.Standard.Cache,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.config = finalConfig
    this.feature.registerExtraReducers(
      extraReducers.resetOnContextChange(collection),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export interface Params<TTypeParams extends ecModels.TypeParams.Constraint>
      extends Pick<plugin.Plugin.Default<TTypeParams>, 'collection'> {
      config?: Config.Options
    }
  }
}
